import { DocumentException } from '../interfaces/DocumentException';
import buildDocument from './buildDocument';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function buildException(level: string, exception: any, message: string, details: any, id: string, correlationId: string): DocumentException {
  const document = buildDocument(level, details, id, correlationId);
  return {
    ...document,
    exception,
    message,
  };
}
